import { get, post, remove } from 'api.vanilla.service';
import { formatErrorMessage } from 'api/helpers';
import { set as setFeedback } from 'feedback.vanilla.service.js';

/**
 * @function fetchAllGlobalIngredientComponentTranslations
 * @description Fetch all allergen translations
 */
export function fetchAllGlobalIngredientComponentTranslations(id, state) {
	const preFilter = `:global_ingredient_component.id=='${id}'`;
	const filter = state.filter ? `${preFilter};${state.filter}` : preFilter;

	// Set params and filter
	const params = {
		limit: state.limit,
		sort: state.sort,
		offset: state.offset,
		filter,
	};

	return get(`/product/global_ingredient_component_translations`, params, null, state.headers)
		.then((res) => {
			return res;
		})
		.catch((err) => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
		});
}

/**
 * @function addGlobalIngredientComponentTranslations
 * @description add
 */
export function addGlobalIngredientComponentTranslations(data) {
	return post(`/product/global_ingredient_component_translations`, data)
		.then((res) => {
			setFeedback('Global ingredient component translation added', 1);
			return res;
		})
		.catch((err) => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
			throw err;
		});
}

/**
 * @function editGlobalIngredientComponentTranslations
 */
export function editGlobalIngredientComponentTranslations(data) {
	return post(`/product/global_ingredient_component_translations/${data.id}`, data)
		.then((res) => {
			setFeedback('Global ingredient component translation edited', 1);
			return res;
		})
		.catch((err) => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
			throw err;
		});
}

/**
 * @function deleteGlobalIngredientComponentTranslations
 */
export function deleteGlobalIngredientComponentTranslations(id) {
	return remove(`/product/global_ingredient_component_translations/${id}`)
		.then((res) => {
			setFeedback('Global ingredient component translation deleted', 1);
			return res;
		})
		.catch((err) => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
			throw err;
		});
}
